

import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToReserva = () => {
    const element = document.getElementById('reserva');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/527551234567?text=Hola, me interesa reservar un transporte', '_blank');
  };

  return (
    <section 
      id="inicio"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/493b47863965cf531708ffec753a97fe.jpg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Transporte Confiable en
            <span className="block text-teal-400">IXTAPA ZIHUATANEJO</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-3xl mx-auto">
            Traslados seguros del aeropuerto a tu hotel. Autos y camionetas para todos los grupos. 
            Servicio profesional 24/7 en el paraíso de la costa mexicana.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button 
              size="lg"
              onClick={scrollToReserva}
              icon={<i className="ri-calendar-check-line"></i>}
              className="text-lg px-8 py-4"
            >
              Reservar Transporte
            </Button>
            <a 
              href="https://wa.me/5217551714622?text=Hola, quiero reservar un transporte"
              className="inline-flex items-center justify-center px-8 py-4 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg mr-2"></i>
              WhatsApp Directo
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-lg mx-auto mb-4">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Servicio 24/7</h3>
              <p className="text-gray-200">Disponibles las 24 horas para tus traslados</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg mx-auto mb-4">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Seguro y Confiable</h3>
              <p className="text-gray-200">Conductores profesionales y vehículos seguros</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-green-600 rounded-lg mx-auto mb-4">
                <i className="ri-whatsapp-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Fácil Reserva</h3>
              <p className="text-gray-200">Reserva por WhatsApp o correo electrónico</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

